export default __webpack_public_path__ + "static/media/autohound-logo-orange.cd78dd52.png";